import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {Zeitstate} from '../../store/reducer/zeiterfassung.reducer';
import {SpesenartItem} from '../../spesenart.model';
import {editZeitStart} from '../../store/actions/Zeit-edit.actions';
import {addZeitStart} from '../../store/actions/Zeit-add.actions';
import {addSpesenStart} from '../../store/actions/spesen-add.actions';
import {editSpesenStart} from "../../store/actions/spesen-edit.actions";
import {addSpesenartStart} from '../../store/actions/spesenart-add.actions';
import {DialogData} from '../spesenart-pageForm/spesenart-pageform.component';
import {toFixed} from 'wijmo/wijmo';
import {editSpesenartStart} from '../../store/actions/spesenart-edit.actions';


@Component({
  selector: 'app-spesenart-formdialog',
  templateUrl: './spesenart-formdialog.component.html',
  styleUrls: ['./spesenart-formdialog.component.scss']
})


export class SpesenartFormdialogComponent implements OnInit {



  constructor(public dialogRef: MatDialogRef<SpesenartFormdialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              public store: Store<{ zeiterfassung: Zeitstate }>)
  {
    dialogRef.disableClose = true;
    this.spesenartForm.patchValue({
      code: data.code,
      bezeichnung: data.bezeichnung,
      ansatzInt: data.ansatzInt.toFixed(2),
      ansatzExt: data.ansatzExt.toFixed(2),
      konto: data.konto,
      firmaId: data.firmaId,
      id: data.id,
      projektId: data.projektId,
    });

  }

  public spesenartForm = new FormGroup({
    code: new FormControl('', [ Validators.maxLength(255)]),
    konto: new FormControl('' , [ Validators.maxLength(255)]),
    ansatzInt: new FormControl('', [Validators.required, Validators.maxLength(255)]),
    ansatzExt: new FormControl('', [Validators.required , Validators.maxLength(255) ]),
    bezeichnung: new FormControl('' , [Validators.required, Validators.maxLength(255)]),
    firmaId: new FormControl(''),
    id: new FormControl(''),
  });

  public getErrorMessage(formField: string): string {
    const formControl = this.spesenartForm.get(formField);
    if ( formControl.hasError('required')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.pflichtfeld`;
    }
    else if ( formControl.hasError('minlength')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.minlength`;
    }
    else if ( formControl.hasError('maxlength')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.maxlength`;
    }
    else if ( formControl.hasError('min')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.min`;
    }
    else if ( formControl.hasError('pattern')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.pattern`;
    }
    return 'pages.zeitverwaltung.spesenDialog.err.generic';
  }

  public handleSubmitClick(): void{

    if (!this.spesenartForm.value.id){
      this.store.dispatch(addSpesenartStart({item: this.spesenartForm.value}));
    }
    else{
      this.store.dispatch(editSpesenartStart({item: this.spesenartForm.value}));
    }
    this.dialogRef.close(true);
  }


  public handleCancelClick(): void{
    this.dialogRef.close(true);
  }


  ngOnInit(): void {}

}
